/**
 * TrustBadges Component
 * Compact trust indicators strip
 */

import { motion } from 'motion/react';
import {
  IconShieldCheck,
  IconShippingFast,
  IconSupport,
  IconReturn,
} from '../ui/Icons';

const badges = [
  { icon: IconShieldCheck, text: 'Genuine Products' },
  { icon: IconShippingFast, text: 'Free Next-Day Delivery' },
  { icon: IconSupport, text: 'Expert Support' },
  { icon: IconReturn, text: '30-Day Returns' },
];

export function TrustBadges() {
  return (
    <section className="py-4 bg-surface-coal/50 border-b border-surface-slate/20">
      <div className="container-wide">
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
          {badges.map((badge, i) => (
            <motion.div
              key={badge.text}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: i * 0.05 }}
              className="flex items-center gap-2 text-sm text-accent-silver"
            >
              <badge.icon size={16} className="text-brand-orange" />
              <span>{badge.text}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
